import MainUserSetting from "../../components/user-setting/main-user-setting";

function UserSetting() {
  return (
    <div className="w-[90%] lg:w-[95%] mx-auto mt-8">
      <MainUserSetting/>
    </div>
  );
}

export default UserSetting;


